import React, {useEffect, useContext, useState} from "react";
import LoaderAnim from "../../components/LoaderAnim/index";
import {useDataApi, API} from "../../components/API/index";
import Context, {Actions} from '../../reducers/Context'
import NavButton from "../../components/NavButton";
import FormInput from "../../components/FormInputs/FormInput";
import useForm, {FormContext} from "react-hook-form"


const ForgotPassword = props => {
    const {dispatch, state} = useContext(Context);
    const hookForm = useForm();
    const [statusText, setStatusText] = useState();
    const {data, isLoading, isError, doFetch} = useDataApi("");

    const onSubmit = (_data) => {
        // console.log("dispatch", _data);
        doFetch(`${API.FORGOTTEN_PASSWORD}?searchFor=${_data.emailOrUsername}`);
    };

    useEffect(() => {
        if (data && !data.response.error && data.response.statusText) {
            // console.log("got data", data);
            setStatusText(data.response.statusText);
        }
    }, [data]);

    return (
        <>
            <div className="afs-msm-stage-content">
                {isError && <div>Something went wrong ...</div>}
                {isLoading ? (
                    <LoaderAnim/>
                ) : (
                    statusText ? (<div className="add-all-padding">{statusText}</div>) : (
                        <div>
                            <div className="add-all-padding">Please enter your username OR your registered email
                                address
                                below - any matching account details will be emailed to you with further
                                instructions</div>

                            <FormContext {...hookForm} >
                                <form>
                                    <div className="afs-msm-input-holder add-all-padding">
                                        <FormInput
                                            name="emailOrUsername"
                                            type="text"
                                            label="Username or Email"
                                            helper=""
                                            placeholder=""
                                            validation={{required: true, minLength: 3}}
                                        />
                                    </div>
                                    <NavButton
                                        colour="teal"
                                        className="afs-msm-inline-button btn add-horiz-margin"
                                        text="SUBMIT"
                                        onClick={hookForm.handleSubmit(onSubmit)}
                                    />
                                </form>
                            </FormContext>
                        </div>
                    )
                )}
            </div>
            <div className="afs-msm-stage-action-buttons">
                <NavButton
                    text="CANCEL"
                    actionType={Actions.CANCELLED_LOGIN}
                />
                <NavButton
                    text="BACK TO LOG IN"
                    actionType={Actions.TO_STAGE}
                    payload={{toStage: "login-method"}}
                />
            </div>
        </>
    );
};

export default {
    id: "forgot-password",
    title: "Forgot Password",
    subtitles: [
        ""
    ],
    imageUrl:
        "https://www.teamstats.net/teamstats-media/images/signup-form/squad-blurred.jpg",
    component: ForgotPassword
};
